import { useLazyQuery } from '@apollo/client';
import { gql } from '@apollo/client';
import { useCallback, useState } from 'react';
import saveAs from 'file-saver';
import { convertBase64ToFile } from 'utils/base64FileConversion';

export const SENT_DATA_QUERY = gql`
  query sentData($requestId: Int!, $url: String!) {
    sentData(requestId: $requestId, url: $url) {
      content
      fileName
    }
  }
`;

export const RECEIVED_DATA_QUERY = gql`
  query receivedData($requestId: Int!, $url: String!) {
    receivedData(requestId: $requestId, url: $url) {
      content
      fileName
    }
  }
`;

export function useDownloadSentData({ onStarting = () => {}, onCompleted = () => {}, onError = () => {}, activeService } = {}) {
  const [requestId, setRequestId] = useState();
  const [getFileQuery, { loading: downloading, error, ...rest }] = useLazyQuery(SENT_DATA_QUERY, {
    context: { serviceName: activeService?.name },
    onCompleted: result => {
      onCompleted(result.sentData.requestId);
      saveAs(convertBase64ToFile(result.sentData.content), result.sentData.fileName);
    },
    onError: err => {
      onError(err);
    },
    fetchPolicy: 'network-only'
  });

  const downloadFile = useCallback(
    (requestId, url) => {
      if (!requestId) {
        return;
      }
      setRequestId(requestId);
      onStarting(requestId);
      getFileQuery({ variables: { requestId, url } });
    },
    [getFileQuery, onStarting]
  );

  return [downloadFile, { downloading, requestId, error, ...rest }];
}

export function useDownloadReceivedData({ onStarting = () => {}, onCompleted = () => {}, onError = () => {}, activeService } = {}) {
  const [requestId, setRequestId] = useState();
  const [getFileQuery, { loading: downloading, error, ...rest }] = useLazyQuery(RECEIVED_DATA_QUERY, {
    context: { serviceName: activeService?.name },
    onCompleted: result => {
      onCompleted(result.receivedData.fileName);
      saveAs(convertBase64ToFile(result.receivedData.content), result.receivedData.fileName);
    },
    onError: err => {
      onError(err);
    },
    fetchPolicy: 'network-only'
  });

  const downloadFile = useCallback(
    (requestId, url) => {
      if (!requestId) {
        return;
      }
      setRequestId(requestId);
      onStarting(requestId);
      getFileQuery({ variables: { requestId, url } });
    },
    [getFileQuery, onStarting]
  );

  return [downloadFile, { downloading, requestId, error, ...rest }];
}
